export default "__VITE_ASSET__DkIO92fu__"